export default __webpack_public_path__ + "static/media/marinebg.6e1e6c6d.png";